<template>
    <v-tooltip bottom :disabled="!showLabel">
        <template v-slot:activator="{ on }">
            <v-switch
                :input-value="value"
                color="n2"
                class="mt-0 pt-0"
                :label="label"
                hide-details
                v-on="on"
                @change="$emit('change', $event)"
            />
        </template>
        {{ value ? $t("Billable") : $t("Non-billable") }}
    </v-tooltip>
</template>

<script>
export default {
    name: "BillableSwitch",
    props: {
        value: {
            type: [Number, Boolean],
            default: null
        },
        showLabel: {
            type: Boolean,
            default: true
        },
        label: {
            type: String,
            default: null
        },
    }
}
</script>

<style scoped lang="scss">
.v-input {
    ::v-deep .v-input--switch__thumb {
        background: var(--v-error-base);
        transform: translate(20px, 0) !important;

        &::after {
            content: '';
            width: 16px;
            height: 16px;
            background-size: cover;
            background-image: url('~@/assets/NonBillableIcon-svg.svg');
        }
    }

    ::v-deep .v-label {
        color: var(--v-main-base);
    }

    ::v-deep .v-input--selection-controls__ripple {
        transform: translate(20px, 0) !important
    }

    &.v-input--is-label-active {
        ::v-deep .v-input--switch__thumb {
            background: var(--v-n3-base);
            transform: translate(0, 0) !important;

            &::after {
                background-image: url('~@/assets/BillableIcon-svg.svg');
            }
        }

        ::v-deep .v-input--selection-controls__ripple {
            transform: translate(0, 0) !important;
        }
    }
}
</style>